if (!customElements.get('tab-component')) {
  customElements.define(
    'tab-component',
    class TabComponent extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        const buttons = this.querySelectorAll('.tabs-buttons .button');
        const contents = this.querySelectorAll(
          '.tabs-content-wrapper .tab-content',
        );

        if (!buttons.length || !contents.length) return;

        const deactivateAll = () => {
          buttons.forEach((btn) => {
            btn.classList.remove('button--primary');
            btn.classList.add('button--secondary');
          });
          contents.forEach((content) => content.classList.add('hidden'));
        };

        buttons.forEach((btn, index) => {
          btn.addEventListener('click', () => {
            deactivateAll();
            btn.classList.add('button--primary');
            btn.classList.remove('button--secondary');
            contents[index].classList.remove('hidden');
          });
        });
      }
    },
  );
}
